module.exports = __webpack_public_path__ + "img/feather.6adc8dea.svg";